import React, {Component} from "react"

import {TitleSection, LoginForm} from "~/components/"
import {withTranslation} from "react-i18next"

class LoginView extends Component {
  render() {
    return (
      <div>
        <TitleSection>
          <h3>{this.props.t("login.title")}</h3>
        </TitleSection>
        <LoginForm />
      </div>
    )
  }
}

export default withTranslation()(LoginView)



// WEBPACK FOOTER //
// ./src/views/LoginView.js